import styled from 'styled-components';

import PanelGroupBlock from 'blocks/PanelGroup/index';
import StyledPanelBody from './StyledPanelBody';

const PanelGroup = styled(PanelGroupBlock)``;

PanelGroup.Body = StyledPanelBody;

export default PanelGroup;



// WEBPACK FOOTER //
// ./src/kentico-blocks/SimpleAccordion/PanelGroup/index.jsx